"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "2.32.0", "build_date": "2021-10-27T06:33:43.472Z", "build_branch": "2.32.0", "build_commit": "c94312401ac3e45697d8883f2e7d981c7d1d3348" };
